<div class="error-container">
  <div class="error-header">
    <img src="assets/500-status-logo.png" alt="Error Icon" />
    <p>Недоступно.</p>
  </div>
</div>